import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { ROUTE, TOP_LEVEL_CATEGORY_ID } from 'app/constants/AdminBrowseConstants';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import AdminBrowseCategoriesPageRoute from './AdminBrowseCategoriesPageRoute';
import AdminBrowseHomeCreatePageRoute from './AdminBrowseHomeCreatePageRoute';
import AdminBrowseHomeEditPageRoute from './AdminBrowseHomeEditPageRoute';
import AdminBrowseHomePageRoute from './AdminBrowseHomePageRoute';

const DEFAULT_TOP_LEVEL_CATEGORY_ID = TOP_LEVEL_CATEGORY_ID.COLLECTION;

export default (
  <Route path={ROUTE.ADMIN}>
    <MainLayout>
      <Switch>
        <Route exact path={ROUTE.ADMIN_BROWSE}>
          <Redirect to={ROUTE.ADMIN_BROWSE_HOME} />
        </Route>

        <Route path={ROUTE.ADMIN_BROWSE_HOME}>
          <Switch>
            <Route exact path={ROUTE.ADMIN_BROWSE_HOME}>
              <AdminBrowseHomePageRoute basePageRoute={ROUTE.ADMIN_BROWSE_HOME} />
            </Route>
            <Route exact path={ROUTE.ADMIN_BROWSE_HOME_CREATE}>
              <AdminBrowseHomeCreatePageRoute />
            </Route>
            <Route exact path={`${ROUTE.ADMIN_BROWSE_HOME_EDIT}/:browseHomePageId`}>
              <AdminBrowseHomeEditPageRoute />
            </Route>
            <Route>
              <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />
            </Route>
          </Switch>
        </Route>

        <Route path={ROUTE.ADMIN_BROWSE_CATEGORIES}>
          <Switch>
            <Route exact path={ROUTE.ADMIN_BROWSE_CATEGORIES}>
              <Redirect to={`${ROUTE.ADMIN_BROWSE_CATEGORIES}${DEFAULT_TOP_LEVEL_CATEGORY_ID}`} />
            </Route>

            <Route path={`${ROUTE.ADMIN_BROWSE_CATEGORIES}/:categoryId/:languageKey?`}>
              <AdminBrowseCategoriesPageRoute basePageRoute={ROUTE.ADMIN_BROWSE_CATEGORIES} />
            </Route>
          </Switch>
        </Route>

        <Route>
          <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />
        </Route>
      </Switch>
    </MainLayout>
  </Route>
);
